import { useState, useEffect, useCallback } from 'react';

interface NavItem {
  label: string;
  href: string;
}

const navItems: NavItem[] = [
  { label: '首页', href: '#hero' },
  { label: '精选专题', href: '#carousel' },
  { label: '热播榜单', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
  { label: '精彩预告', href: '#media' },
  { label: '移动观影', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 40);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-fill text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950 tracking-wide whitespace-nowrap">
              人人影院
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  item.label === '首页'
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/50'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200/50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索</span>
            </button>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#hero');
              }}
              className="px-4 py-2 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即观看
            </a>
          </div>

          <button
            type="button"
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:text-foreground-950 hover:bg-background-200/50 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/60">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className={`px-3 py-2.5 rounded-lg text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  item.label === '首页'
                    ? 'text-primary-500 font-medium bg-primary-500/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/50'
                }`}
              >
                {item.label}
              </a>
            ))}
            <div className="pt-2 border-t border-background-200/60 mt-1">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick('#hero');
                }}
                className="block w-full text-center px-4 py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即观看
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}